<template>

    <v-container class="pa-0 px-1" fluid v-if="!loading">
        <v-card class="pa-2">
                <v-row cols="12">
                    <v-col cols="2">
                        <btn_component type="avatar_text" :tooltip="pten_hist_short" data="History" text="H" size="small" @actionClick="viewHistoryDialog(pten_code, pten_hist_long)" v-if="addAction"/>
                    </v-col>
                    <v-col cols="8" ><v-card-title class="pt-0 pb-0 justify-center">Actions</v-card-title></v-col>
                    <v-col cols="2" v-if="addAction">
                        <v-spacer/>
                        <btn_plus ref="btn_plus" data="createAction" @actionClick="actionClick" tooltip="Add action" :size="20"/>
                        <btn_component ref="btn_mail" type="icon" icon="mdi-email-fast-outline" data="infoEmail" @actionClick="actionClick" tooltip="email" size="small"/>
                        <btn_component ref="btn_export" type="icon" icon="mdi-microsoft-excel" data="excelExport" @actionClick="buildReport" tooltip="export" size="small"/>
                    </v-col>
                    <v-col cols="1" v-if="typeList==='search'">
                    </v-col>
                    <v-col cols="1" v-if="typeList==='search'">
                        <v-btn class="primary" small @click="buildReport" :disabled="disableExport" color="success">
                            <v-icon small class="pr-2">mdi-microsoft-excel</v-icon>
                        <span class="pr-1">Export</span>
                    </v-btn>
                    </v-col>
                    <v-col cols="2" v-if="!addAction&&typeList!=='search'"></v-col>
                </v-row>
            <v-divider></v-divider>
            <v-row cols="12">
                <v-col :cols="typeList==='search' ? 3 : 6">
                    <v-text-field v-model="search" label="Search actions" single-line hide-details prepend-icon="mdi-magnify"></v-text-field>
                </v-col>
                <v-col cols="3" v-if="typeList==='search'">
                    <v-select v-model="selected_agent" :items="agents" item-value="gebr_code" item-text="gebr_naam" label="Select an agent" :disabled="!isAdmin" :clearable="isAdmin"></v-select>
                </v-col>
                <v-col cols="6">
                    <selector :options="filterCodes" option_field="filterSelection" label="Filter on status" @updateData="updateData" />
                </v-col>
            </v-row>
            <v-data-table 
                :items="filteredActions" 
                :items-per-page="10" 
                :footer-props="{'items-per-page-options': [10, 50, 100, 200, -1]}"
                :headers="headers"
                :search="search">
                <template v-slot:item="action">
                    <tr :class="action.item.ptac_stat==='Overdue'?'red':action.item.ptac_stat==='Done'?'grey':''">
                        <!-- <td v-if="action.item.ptac_encrid!==''&&!addAction" class="pr-0 click_cell" @click="openLead(action.item.pten_encrid)">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <span v-bind="attrs" v-on="on">{{ action.item.pten_action }}</span>
                                </template>
                                <span>Open lead {{ action.item.pten_code }}</span>
                            </v-tooltip>
                        </td> -->
                        <td v-if="action.item.ptac_encrid!==''&&!addAction" class="pr-0">
                            {{ action.item.pten_code }}
                        </td>
                        <td v-if="action.item.ptac_encrid!==''&&addAction" class="pr-0 click_cell" @click="openAction(action.item)">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <span v-bind="attrs" v-on="on">{{ action.item.pten_action }}</span>
                                </template>
                                <span>Update this action</span>
                            </v-tooltip>
                        </td>
                        <td v-if="action.item.ptac_encrid!==''" class="px-0"><btn_audit table="ptac" :encrid="action.item.ptac_encrid" :size=20 tooltip="Action audit" /></td>
                        <td v-if="action.item.ptac_encrid===''" class="click_cell" @click="createAction(action.item.pten_encrid)">{{ action.item.pten_action }}</td>
                        <td v-if="action.item.ptac_encrid===''"></td>
                        <td v-if="typeList==='search'">{{ action.item.ptac_create_dt }}</td>
                        <td v-if="typeList==='search'">{{ action.item.ptac_gebr_code }}</td>
                        <td v-if="action.item.ptac_encrid!==''&&!addAction" class="pr-0 click_cell" @click="openLead(action.item.pten_encrid)">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <span v-bind="attrs" v-on="on">{{ action.item.pten_naam }}</span>
                                </template>
                                <span>Open lead {{ action.item.pten_code }}</span>
                            </v-tooltip>
                        </td>
                        <td v-else>{{ action.item.pten_naam }}</td>
                        <td>{{ action.item.patp_oms }}</td>
                        <td>{{ action.item.ptac_naam }}</td>
                        <td>{{ action.item.ptac_stat }}</td>
                        <td v-if="action.item.ptac_stat!=='Done'">{{ action.item.ptac_actie_dt }}</td>
                        <td v-else>{{ action.item.ptac_done_dt }}</td>
                        <td v-if="typeList==='search'"><longTextView :long_text="action.item.ptac_oms" :max_width="125"/></td>
                        <td v-if="typeList==='search'"><longTextView :long_text="action.item.ptac_result" :max_width="125"/></td>
                        <td v-if="typeList==='search'">
                            <btn_component type="avatar_text" :tooltip="action.item.ptac_hist" data="History" text="H" size="small" @actionClick="viewHistoryDialog(action.item.pten_code, action.item.ptac_hist_long)"/>
                        </td>
                        <td>
                            <div v-if="action.item.ptac_encrid!==''">
                                <btn_component type="text" tooltip="Edit action"  :data="action.item" text="Edit"  size="x-small" @actionClick="openAction"  v-if="action.item.ptac_stat!=='Done'"/>
                                <!-- <btn_component type="text" tooltip="Complete action" :data="action.item" text="Complete" size="x-small" @actionClick="setComplete" v-if="action.item.ptac_stat!=='Done'"/> -->
                            </div>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-card>
        <onAction ref="onAction" @actionClick="actionClick" />
        <closeAction ref="closeAction" @actionClick="actionClick" />
        <showProgress ref="showProgress"/>
        <viewHistory ref="viewHistory"/>
    </v-container>
    <v-container class="pa-5 px-1" fluid v-else>
        <cardWait/>
    </v-container>
</template>

<script>
    import showProgress from "@/components/showProgress.vue";
    import btn_audit from "@/components/ui/buttons/btn_audit.vue";
    import btn_component from "@/components/ui/buttons/btn_component.vue";
    import btn_plus from "@/components/ui/buttons/btn_plus.vue";
    import longTextView from "@/components/ui/fields/longTextView.vue";
    import selector from "@/components/ui/selectors/selector.vue";
    import onAction from "@/components/pten/onAction.vue";
    import closeAction from "@/components/pten/closeAction.vue";
    import viewHistory from "@/components/pten/viewHistory.vue";
    import cardWait from "@/components/pten/cardWait.vue";
    
    export default {
        components: {
            btn_audit,
            btn_component,
            btn_plus,
            longTextView,
            selector,
            onAction,
            closeAction,
            showProgress,
            viewHistory,
            cardWait,
        },
        props: {
            pten_encrid :{
                type: String,
                requred: false,
                default: "",                
            },
            agent: {
                type: String,
                required: false,
                default: "",
            },
            addAction: {
                type: Boolean,
                required: false,
                default: false,
            },
            typeList: {
                type: String,
                required: false,
                default: "dashboard",                
            }
        },
        data() {
            return {
                loading: true,
                disableExport: false,
                isAdmin: false,
                selected_agent: "",
                agents: [],
                last: "",
                actions: [],
                filteredActions: [],
                filterCodes: [], 
                filterSelection: [], 
                search: "",
                headers: [],
                pten_code: "",
                pten_hist_short: "",    
                pten_hist_long: "",
            }
        },
        mounted() {
            this.selected_agent = this.agent;
            this.getHeaders();
            this.getActions();
        },
        watch: {
            selected_agent(value) {
                if (value !== this.last) {
                    this.last = value;
                    this.getActions();
                }
            },
        },
        methods: {
            getActions() {
                this.loading = true;
                this.$axios.post("ares/json/ares/pten/searchPtenAction.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "searchPtenAction"
                    },
                    searchPtenAction: {
                        pten_encrid: this.pten_encrid,
                        agent: this.selected_agent === null ? "" : this.selected_agent,
                        stat_codes: this.getFilterStatus(),
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.actions = res.data.searchPtenAction;
                        this.filterCodes = res.data.statKeuzes;                        
                        this.filterSelection = this.getFilterStatus();
                        this.filteredActions = this.getFilteredActions();
                        //this.selected_agent = res.data.agent;
                        this.agents = res.data.agentKeuzes;
                        this.isAdmin = res.data.isAdmin;
                        this.pten_code = res.data.pten_code;
                        this.pten_hist_short = res.data.pten_hist_short;
                        this.pten_hist_long = res.data.pten_hist_long;
                        this.loading = false;
                    }
                });
            },
            getFilteredActions() {
                let selected = [];
                for (let i = 0; i<this.actions.length; i++) {
                    for (let j = 0; j<this.filterCodes.length; j++) {
                        if (this.filterCodes[j].Option === this.actions[i].ptac_stat && this.filterCodes[j].isSelected) {
                            selected.push(this.actions[i])
                        }
                    }
                }
                return selected;
            },
            getFilterStatus() {
                // console.log(this.filterSelection)
                let selected = [];
                for (let i = 0; i<this.filterCodes.length; i++) {
                    if (this.filterCodes[i].isSelected) {
                        selected.push(this.filterCodes[i].Option)
                    }
                }
                return selected;
            },
            getHeaders() {
                switch (this.typeList) {
                    case "search": {
                        this.headers = [
                            {text: "Id", value: "pten_action", tdClass: "align-text-top" },
                            {text: "", value: "", width: "12px", sortable: false},
                            {text: "Created", value: "ptac_create_dt"},
                            {text: "Created by", value: "ptac_gebr_code"},
                            {text: "Lead", value: "pten_naam"},
                            {text: "Type", value: "patp_oms"},
                            {text: "For", value: "ptac_naam"},
                            {text: "Status", value: "ptac_stat"},
                            {text: "Due/Done", value: "ptac_actie_dt"},
                            {text: "Description", value: "ptac_oms"},
                            {text: "Result", value: "ptac_result"},
                            {text: "History", value: "ptac_hist"},
                            {text: "Actions", value: "", width: "170px"},
                        ];
                        break;
                    }
                    default: {
                        this.headers = [
                            {text: "Id", value: "pten_action", tdClass: "align-text-top" },
                            // {text: "Created", value: "ptac_create_dt"},
                            // {text: "Created by", value: "ptac_gebr_code"},
                            {text: "", value: "", width: "12px", sortable: false},
                            {text: "Lead", value: "pten_naam"},
                            {text: "Type", value: "patp_oms"},
                            {text: "For", value: "ptac_naam"},
                            {text: "Status", value: "ptac_stat"},
                            {text: "Due/Done", value: "ptac_actie_dt"},
                            // {text: "Description", value: "ptac_oms"},
                            // {text: "Result", value: "ptac_result"},
                            {text: "Actions", value: "", width: "80px"},
                        ];
                        break;
                    }
                }
            },
            openLead(pten_encrid) {
                this.$router.open('/pten/onPten/' + pten_encrid)
            },
            openAction(item) {
                this.$refs.onAction.openDialog(item.pten_encrid, item.ptac_nr);
            },
            createAction(pten_encrid) {
                this.$refs.onAction.openDialog(pten_encrid, 0);
            },
            updateData(data) {
                switch (data.field) {
                    case "filterSelection":
                        for (let i = 0; i<this.filterCodes.length; i++) {
                            this.filterCodes[i].isSelected = false;
                            for (let j = 0; j<data.value.length; j++) {
                                if (this.filterCodes[i].Option === data.value[j].Option) {
                                    this.filterCodes[i].isSelected = true;
                                }
                            }
                        }                        
                        this.filterSelection = this.getFilterStatus();
                        this.filteredActions = this.getFilteredActions();                    
                        break;
                    default:
                        alert("updateData - field not found");
                }
            },
            actionClick(action) {
                switch (action) {
                    case "refreshActions":
                        this.getActions();
                        break;
                    case "createAction":
                        if (this.pten_encrid !== "") {
                            this.createAction(this.pten_encrid);
                        }
                        break;
                    default:
                        this.$emit("actionClick", action);
                }
            },
            setComplete(ptac) {
                this.$refs.closeAction.openDialog(ptac);
            },
            buildReport() {
                this.disableExport = false;
                this.$refs.showProgress.open();
                this.$axios.post("ares/json/ares/pten/excelExportPtenActions.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "excelExportPtenActions"
                    },
                    excelExportPtenActions: {
                        items: this.filteredActions,
                    },
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.$refs.showProgress.close();
                        window.open(res.data.excelExportPtenActions.filename, '_blank');
                    }
                    this.$refs.showProgress.close();
                    this.disableExport = false;
                });
            },
            viewHistoryDialog(pten_code, text) {
                this.$refs.viewHistory.openDialog(pten_code, text);
            },
        }
    };
</script> 

<style scoped>
    .align-text-top {
        vertical-align: top;
    }
    .click_cell {
        cursor: pointer;
        text-decoration: underline;
        color: blue;
    }
    .audit {
        cursor: pointer;
    }
    .actions {
        display: inline-block;
    }
    .nopad {
        padding: 0px !important;
    }
</style>
